import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconInfoInformationCircle = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24h-24v-24h24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }), /*#__PURE__*/React.createElement("line", {
    x1: "11",
    x2: "13.31",
    y1: "15.5",
    y2: "15.5",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    points: "12.159,15.5 12.159,11.25 11.009,11.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M12.1 8.24726v0c0 .138071-.111929.25-.25.25 -.138071 0-.25-.111929-.25-.25 0-.138071.111929-.25.25-.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M11.85 7.99726h-1.09278e-08c.138071-6.03528e-09.25.111929.25.25"
  })));
};
//# sourceMappingURL=IconInfoInformationCircle.js.map